/* eslint-disable func-names */
import axios from '@/axios';

export const updateGenericAction = async ({ indentNo, values }) => {
  try {
    return await axios.put(`/generic-indent/${indentNo}`, { data: values });
  } catch (error) {
    throw error;
  }
};
export const getIncoTerms = async (params) => {
  try {
    return await axios('/exim/incoterm', { params });
  } catch (error) {
    throw error;
  }
};
export const getBolTypes = async () => {
  try {
    return await axios('/generic-indent/bol_type');
  } catch (error) {
    throw error;
  }
};
export const createMasterIndent = async (data) => {
  try {
    return await axios.post('/exim/indent', { data });
  } catch (error) {
    throw error;
  }
};
export const getChildIndents = async (indentNo) => {
  try {
    return await axios(`/exim/indent/${indentNo}/legs`);
  } catch (error) {
    throw error;
  }
};
export const searchMasterIndent = async ({ params }) => {
  try {
    return await axios('/exim/indent', { params });
  } catch (error) {
    throw error;
  }
};
export const fetchAttachments = async () => {
  try {
    return await axios('/exim/attachment');
  } catch (error) {
    throw error;
  }
};
export const cancelMasterIndent = async (indentNo, cancelComment) => {
  try {
    return await axios.put(`/exim/indent/${indentNo}/cancel`, { data: { cancel_comment: cancelComment } });
  } catch (error) {
    throw error;
  }
};
export const deliverMasterIndent = async (indentNo, date) => {
  try {
    return await axios.put(`/exim/indent/${indentNo}/deliver`, { delivered_at_consignee: date });
  } catch (error) {
    throw error;
  }
};
export const findMasterIndent = async (indentNo) => {
  try {
    return await axios(`/exim/indent/${indentNo}/edit`);
  } catch (error) {
    throw error;
  }
};
export const updateMasterIndent = async (indentNo, data) => {
  try {
    return await axios.put(`/exim/indent/${indentNo}`, { data });
  } catch (error) {
    throw error;
  }
};
export const fetchMasterCustomFields = async (type) => {
  try {
    return await axios(`/exim/master_custom_fields?type=${type}`);
  } catch (error) {
    throw error;
  }
};


export const updateApproval = async (indentNo, data) => {
  try {
    console.log(indentNo)
    return await axios.put(`/generic-indent-approval/${indentNo}`,  { data });
  } catch (error) {
    throw error;
  }
};
